export const DIN5008_LANDING_PATH = "/de/lebenslauf-generator-din-5008" as const;
export const CHANCENKARTE_RESUME_LANDING_PATH =
  "/en/chancenkarte-resume-builder" as const;
export const ATS_EVIDENCE_LANDING_PATH =
  "/de/ats-lebenslauf-anforderungen-belegen" as const;

export const PUBLIC_SEO_LANDINGS = [
  {
    label: "DIN 5008 Lebenslauf Generator (German)",
    path: DIN5008_LANDING_PATH,
    locale: "de",
    lastmod: "2026-10-15",
  },
  {
    label: "Chancenkarte Resume Guide (English)",
    path: CHANCENKARTE_RESUME_LANDING_PATH,
    locale: "en",
    lastmod: "2026-10-15",
  },
  {
    label: "ATS Resume Evidence Check (German)",
    path: ATS_EVIDENCE_LANDING_PATH,
    locale: "de",
    lastmod: "2026-10-07",
  },
] as const;

const ROUTE_OWNED_LOCALIZED_PATHS = new Set(
  PUBLIC_SEO_LANDINGS.map((landing) => landing.path),
);

export function isPublicSeoLandingPath(pathname: string): boolean {
  return ROUTE_OWNED_LOCALIZED_PATHS.has(
    pathname as (typeof PUBLIC_SEO_LANDINGS)[number]["path"],
  );
}

export interface LegacySeoRedirect {
  readonly status: 308;
  readonly location: typeof ATS_EVIDENCE_LANDING_PATH;
}

/**
 * Canonical replacement for the retired vendor-specific ATS URL. The target
 * explains evidence-based ATS review without implying Personio certification.
 */
export function getLegacySeoRedirect(pathname: string): LegacySeoRedirect | null {
  const normalized = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  if (normalized !== "/de/personio-ats-lebenslauf") return null;

  return {
    status: 308,
    location: ATS_EVIDENCE_LANDING_PATH,
  };
}
